import { BankingGridLayout } from './BankingGrid.style';

function BankingGrid({ children, ...delegated }) {
  return <BankingGridLayout {...delegated}>{children}</BankingGridLayout>;
}

export default BankingGrid;
